module.exports = __webpack_public_path__ + "img/helpCenter.383e977b.svg";